import React, { useState } from 'react';
import Plate from '../ui/Plate';
import { IconCalendar, IconGear, IconFuel, IconGauge, IconCamera, IconArrowRight } from '../ui/Icons';

const CarCard = ({
  image,
  title,
  year,
  transmission,
  fuel,
  price,
  mileage,
  onViewDetails
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <article className="car-card" onClick={onViewDetails}>
      <div className="car-image">
        {imageFailed ? (
          <div className="car-image-placeholder">
            <IconCamera />
            <span>Photo coming soon</span>
          </div>
        ) : (
          <>
            <img className="car-image-backdrop" src={image} alt="" aria-hidden="true" loading="lazy" />
            <img
              className="car-image-main"
              src={image}
              alt={title}
              loading="lazy"
              onError={() => setImageFailed(true)}
            />
            <div className="car-image-scrim" aria-hidden="true" />
            <span className="car-mileage-chip">
              <IconGauge /> {(mileage || 0).toLocaleString()} mi
            </span>
          </>
        )}
      </div>
      <div className="car-details">
        <h3 className="car-title">{title}</h3>
        <div className="car-specs">
          <span><IconCalendar /> {year}</span>
          <span><IconGear /> {transmission}</span>
          <span><IconFuel /> {fuel}</span>
        </div>
        <div className="car-footer">
          <Plate className="car-price-plate">£{(price || 0).toLocaleString()}</Plate>
          <button
            type="button"
            className="view-btn"
            aria-label={`View details for ${title}`}
          >
            <IconArrowRight />
          </button>
        </div>
      </div>
    </article>
  );
};

export default CarCard;
